import { Select } from '@chakra-ui/react';
import { ChangeEvent, FC, useMemo } from 'react';
import { FilterProps } from 'react-table';

const SelectColumnFilter: FC<FilterProps<any>> = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    const options = useMemo(() => {
        const optionsSet = new Set<string>();
        preFilteredRows.forEach((row) => {
            if (Array.isArray(row.values[id])) {
                row.values[id].forEach((v: string) => optionsSet.add(v));
            } else {
                optionsSet.add(row.values[id]);
            }
        });

        return [...optionsSet.values()];
    }, [id, preFilteredRows, preFilteredRows.length]);

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setFilter(e.target.value || undefined);
    };
    return (
        <Select size="sm" value={filterValue} onChange={handleChange}>
            <option value=""> ALL </option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </Select>
    );
};

export default SelectColumnFilter;
